import { IconHeading2Outline18 as Heading2 } from "nucleo-ui-outline-18"

import { ShortcutSymbols } from "@productlane/lib/src/shortcut-symbols"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const heading2Command: SlashCommandDefinition = {
	key: "heading2",
	title: "Heading 2",
	icon: <Heading2 strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor
			.chain()
			.focus()
			.deleteRange(range)
			.setNode("heading", { level: 2 })
			.run()
	},
	group: "headings",
	shortcutIcons: [
		ShortcutSymbols.CTRL,
		ShortcutSymbols.SHIFT,
		ShortcutSymbols[2],
	],
}
